export default "__VITE_ASSET__CBTKF7oK__"